import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Types ───

export interface AppointmentProviderRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  full_name: string | null;
  display_name: string | null;
  specialty: string | null;
  email: string | null;
  mobile: string | null;
  avatar_color: string | null;
  active: number | null; // 0/1
  created_at: string | null;
  updated_at: string | null;
}

export interface AppointmentProviderTypeRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  provider_id: string | null;
  type: string | null;
  created_at: string | null;
  updated_at: string | null;
}

// ─── Queries ───

export function qAppointmentProviders(): QuerySpec<[]> {
  return {
    key: ['appointment-providers'] as const,
    sql: `SELECT * FROM appointment_providers ORDER BY full_name ASC`,
    params: [],
    watch: ['appointment_providers'],
  };
}

export function qAppointmentProviderTypes(): QuerySpec<[]> {
  return {
    key: ['appointment-provider-types'] as const,
    sql: `SELECT * FROM appointment_provider_types ORDER BY provider_id, type ASC`,
    params: [],
    watch: ['appointment_provider_types'],
  };
}

// ─── Helpers ───

export function mapProviderRowToUI(
  row: AppointmentProviderRow,
  typeRows: AppointmentProviderTypeRow[],
) {
  const types = typeRows.filter((t) => t.provider_id === row.id).map((t) => t.type as string);
  return {
    id: row.id,
    fullName: row.full_name ?? '',
    displayName: row.display_name ?? '',
    specialty: row.specialty ?? '',
    types,
    email: row.email ?? '',
    mobile: row.mobile ?? '',
    avatarColor: row.avatar_color ?? '#2980b9',
    active: row.active === 1,
  };
}

export function mapUIToProviderColumns(ui: {
  fullName: string;
  displayName: string;
  specialty: string;
  email: string;
  mobile: string;
  avatarColor: string;
  active: boolean;
}) {
  return {
    full_name: ui.fullName,
    display_name: ui.displayName || null,
    specialty: ui.specialty || null,
    email: ui.email || null,
    mobile: ui.mobile || null,
    avatar_color: ui.avatarColor,
    active: ui.active ? 1 : 0,
    updated_at: new Date().toISOString(),
  };
}
